import { memo, useEffect, useRef } from 'react';
import { PROMPT_LIBRARY_TEMPLATES } from '../constants/promptLibraryTemplates';
import { Mixpanel } from '../services/Mixpanel';

function PromptLibraryInline({
  onSelectPrompt,
  isLDidentified,
  templates = PROMPT_LIBRARY_TEMPLATES,
}) {
  const hasFiredRef = useRef(false);

  useEffect(() => {
    if (isLDidentified && !hasFiredRef.current) {
      hasFiredRef.current = true;
      Mixpanel.track('Prompt Library Inline Impression');
    }
  }, [isLDidentified]);

  return (
    <section className='w-full max-w-[1168px] mx-auto'>
      <h2 className='text-xl font-normal text-gray-900 mb-10 text-center'>
        <span>Explore what&apos;s possible with Diffit</span>
      </h2>
      <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4'>
        {templates.map((t, idx) => (
          <button
            key={t.prompt}
            type='button'
            // The BTS "Explore Diffit" tour step points its arrow + highlight at
            // the first tile specifically (see exploreTourSteps.js), not the whole grid.
            data-tutorial-id={idx === 0 ? 'bts-jtbd-first-card' : undefined}
            onClick={() => onSelectPrompt(t)}
            className='flex flex-col gap-4 rounded-xl border border-gray-200 bg-white p-5 pb-14 sm:min-h-[130px] text-left transition-all hover:shadow-[0_4px_16px_rgba(0,0,0,0.06)] hover:border-gray-300'>
            <span className='text-[28px] leading-none'>{t.emoji}</span>
            <span className='text-base text-gray-800 leading-snug'>{t.label}</span>
          </button>
        ))}
      </div>
    </section>
  );
}

// Memoized so the workshop input's placeholder animation doesn't re-render the
// 21-tile grid on every typed character.
export default memo(PromptLibraryInline);
